/**
 * Move Related products sections into matching cart portal slots by portal ID.
 * Moves the live Shopify section node (no clone) so recommendation JS keeps working.
 *
 * Cart AJAX updates replace #MainCart innerHTML, so portaled sections are evacuated
 * before the replace and moved back afterward. After re-portal, refresh any Swiper
 * instances so slide spacing survives the move.
 */
(function () {
  if (window.Shopify && Shopify.designMode) return;

  var stash;

  function getStash() {
    if (stash && document.body.contains(stash)) return stash;
    stash = document.getElementById('related-products-portal-stash');
    if (!stash) {
      stash = document.createElement('div');
      stash.id = 'related-products-portal-stash';
      stash.hidden = true;
      document.body.appendChild(stash);
    }
    return stash;
  }

  function evacuate() {
    document.querySelectorAll('[data-related-products-portal-slot] [id^="shopify-section-"]').forEach(function (section) {
      getStash().appendChild(section);
    });
  }

  function refreshSliders(root) {
    root.querySelectorAll('product-slider').forEach(function (slider) {
      if (typeof slider.refreshSlider === 'function') {
        slider.refreshSlider();
      }
    });
  }

  function portal() {
    document.querySelectorAll('[data-related-products-portal-slot]').forEach(function (slot) {
      var id = slot.dataset.portalId;
      if (!id) return;

      var sourceEl = [].find.call(document.querySelectorAll('[data-portal-id="' + id + '"]'), function (el) {
        return !el.closest('[data-related-products-portal-slot]');
      });
      if (!sourceEl) return;

      var section = sourceEl.closest('[id^="shopify-section-"]') || sourceEl;
      var alreadyPortaled = section.parentElement === slot;

      if (!alreadyPortaled) {
        slot.appendChild(section);
      }

      slot.classList.add('is-portaled');
      refreshSliders(slot);
    });
  }

  function ready() {
    portal();
    document.addEventListener('cart:before-dom-update', evacuate);
    document.addEventListener('cart:dom-updated', portal);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', ready) : ready();
})();
